import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class MenuService {
    private menuSidebar$ = new BehaviorSubject<MenuSidebarType>({
        user: [],
        admin: [],
        other: [],
    });
    private menuShortcut$ = new BehaviorSubject<MenuShortcutType[]>([]);

    getMenuSidebar() {
        return this.menuSidebar$.asObservable();
    }

    setMenuSidebar(data: MenuSidebarType) {
        this.menuSidebar$.next(data);
    }

    getMenuShortcut() {
        return this.menuShortcut$.asObservable();
    }

    setMenuShortcut(data: MenuShortcutType[]) {
        this.menuShortcut$.next(data);
    }
}
